import { Media, MediaVariant } from "@gogive/types";

export const DEFAULT_MEDIA_CDN_BASE_URL = "https://media.cdn-gogive.com";

const stripSlashes = (value: string) => value.replace(/^\/+|\/+$/g, "");

export const extractMediaKey = (keyOrUrl?: string | null): string | null => {
  if (!keyOrUrl) return null;
  if (keyOrUrl.startsWith("http://") || keyOrUrl.startsWith("https://")) {
    try {
      return stripSlashes(new URL(keyOrUrl).pathname);
    } catch {
      return stripSlashes(keyOrUrl);
    }
  }
  return stripSlashes(keyOrUrl);
};

export const buildMediaCdnUrl = (
  keyOrUrl?: string | null,
  baseUrl: string = DEFAULT_MEDIA_CDN_BASE_URL
): string | null => {
  const key = extractMediaKey(keyOrUrl);
  if (!key) return null;
  return encodeURI(`${stripSlashes(baseUrl)}/${key}`);
};

type MediaKeys = Pick<
  Media,
  "s3Key" | "thumbKey" | "fullKey" | "linkPreviewKey"
>;

export const getMediaVariantKey = (
  media?: MediaKeys | null,
  variant: MediaVariant = "thumb"
): string | null => {
  if (!media?.s3Key) return null;
  if (variant === "thumb") return media.thumbKey ?? media.s3Key;
  if (variant === "full") return media.fullKey ?? media.s3Key;
  return media.linkPreviewKey ?? media.s3Key;
};

export const buildMediaVariantCdnUrl = (
  media?: MediaKeys | null,
  variant: MediaVariant = "thumb",
  baseUrl: string = DEFAULT_MEDIA_CDN_BASE_URL
): string | null => {
  const key = getMediaVariantKey(media, variant);
  return buildMediaCdnUrl(key, baseUrl);
};
